<script setup lang="ts">
import lodashLowerCase from 'lodash-es/lowerCase';

import { AUTOCOMPLETE_OFF } from '~/constants/form';

// PROPS
const { countryCode } = defineProps({
    countryCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
});

// MODEL
const model = defineModel<string>({ default: '' });
const selectModel = ref<string>(model.value.split(' ')[0] ?? '');
const inputModel = ref<string>(model.value.split(' ')[1] ?? '');

// COMPOSABLES
const { countries } = useCountries();
const { tt } = useTypedI18n();

// WATCHERS
watch(
    () => countryCode,
    () => {
        if (countryCode && countries.value.length > 0 && !inputModel.value) {
            const { rootIddCode } = countries.value.find(c => c.countryCode === countryCode) ?? {};

            if (rootIddCode) {
                selectModel.value = rootIddCode;
            }
        }
    },
    { immediate: true }
);

// HANDLERS
const onChange = (): void => {
    model.value = inputModel.value ? [selectModel.value, inputModel.value].join(' ').trim() : '';
};
</script>

<template>
    <div class="flex gap-1">
        <USelectMenu
            v-model="selectModel"
            :items="countries"
            value-key="rootIddCode"
            label-key="rootIddCode"
            :ui="{
                base: 'w-[116px]',
                focusScope: 'w-[104px]',
            }"
            :search-input="{ placeholder: tt('common.searchPlaceholder') }"
            :disabled="disabled"
            @update:model-value="onChange"
        >
            <template #item="{ item }">
                <UIcon class="text-md" :name="`i-circle-flags-${lodashLowerCase(item.countryCode)}`" />
                {{ item.rootIddCode }}
            </template>
        </USelectMenu>
        <UInput v-model="inputModel" :disabled="disabled" :autocomplete="AUTOCOMPLETE_OFF" @update:model-value="onChange" />
    </div>
</template>
